export default __webpack_public_path__ + "static/media/jingdong.3fa7ec62.webp";